var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyPercentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.559,
    height: 98.246,
    viewBox: "0 0 93.559 98.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_448",
    x: 39.801,
    y: 16.172,
    width: 34.443,
    height: 41.103,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_449",
    x: 51.23,
    y: 28.428,
    width: 26.856,
    height: 28.86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_450",
    x: 35.805,
    y: 16.173,
    width: 26.832,
    height: 28.885,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_451",
    x: 0,
    y: 0,
    width: 93.559,
    height: 98.246,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_335",
    "data-name": "Groupe 335",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_448-2",
    "data-name": "Trac\\xE9 448",
    d: "M129.974-14.628a1.209,1.209,0,0,0,1.629-.312l14.1-20.768a1.172,1.172,0,0,0-.312-1.629,1.172,1.172,0,0,0-1.629.312l-14.1,20.767a1.173,1.173,0,0,0,.312,1.63Zm0,0",
    transform: "translate(-80.66 59.71)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_449-2",
    "data-name": "Trac\\xE9 449",
    d: "M188.577,31.965c2.441,0,4.428-2.442,4.428-5.443-.251-7.223-8.606-7.221-8.856,0,0,3,1.986,5.443,4.429,5.443Zm0-8.539c1.128,0,2.081,1.418,2.081,3.1s-.953,3.1-2.081,3.1-2.082-1.418-2.082-3.1.953-3.1,2.082-3.1Zm0,0",
    transform: "translate(-123.92 13.32)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_334",
    "data-name": "Groupe 334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_450-2",
    "data-name": "Trac\\xE9 450",
    d: "M119.171-32.1c0-3-1.987-5.442-4.428-5.442-5.872.29-5.87,10.6,0,10.885,2.442,0,4.428-2.442,4.428-5.442Zm-6.51,0c0-1.678.954-3.1,2.082-3.1s2.081,1.418,2.081,3.1-.953,3.1-2.081,3.1-2.082-1.418-2.082-3.1Zm0,0",
    transform: "translate(-65.53 59.71)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_451-2",
    "data-name": "Trac\\xE9 451",
    d: "M-21.4-60.813C7.4-52.231,27.333-88.28,4.911-108.2a1.173,1.173,0,0,0-1.655.123,1.174,1.174,0,0,0,.123,1.655C24.194-87.877,5.1-54.56-21.4-63.287V-71.26c0-1-.608-2.421-3.507-3.455a22.692,22.692,0,0,0-10.573-.8C-46.54-97.109-23.9-120.5-2.015-109.977a1.173,1.173,0,0,0,1.569-.539,1.173,1.173,0,0,0-.539-1.57c-23.6-11.376-48.264,13.5-36.873,37.056-.35.1-.687.2-1.006.314-2.9,1.034-3.507,2.45-3.507,3.455v7.81A18.985,18.985,0,0,0-50.5-64.984a1.173,1.173,0,0,0,0,2.347,19.118,19.118,0,0,1,6.182.907c1.607.574,1.945,1.154,1.945,1.245s-.339.671-1.949,1.246a19.664,19.664,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.246,0-.107.411-.776,2.368-1.385a1.173,1.173,0,0,0-.7-2.24C-60.3-63.075-61-61.568-61-60.485v21.21c0,1.006.609,2.421,3.507,3.456a22.026,22.026,0,0,0,13.961,0A7.658,7.658,0,0,0-41.2-37.061a7.642,7.642,0,0,0,2.333,1.242,22.026,22.026,0,0,0,13.961,0,7.637,7.637,0,0,0,2.334-1.242,7.64,7.64,0,0,0,2.334,1.242,22.024,22.024,0,0,0,13.961,0c2.9-1.035,3.507-2.45,3.507-3.456V-49.881c0-1.006-.608-2.421-3.507-3.456a22.025,22.025,0,0,0-13.961,0,10.291,10.291,0,0,0-1.161.492c0-1.53,0-6.068,0-7.664,0-.042,0-.259,0-.3ZM-5.115-44.578c0,.091-.34.672-1.95,1.247a19.678,19.678,0,0,1-12.383,0c-1.611-.576-1.949-1.156-1.949-1.247v-2.338a10.18,10.18,0,0,0,1.161.491,22.019,22.019,0,0,0,13.961,0,10.233,10.233,0,0,0,1.161-.491ZM-23.744-65.957c0,.09-.339.671-1.948,1.246a19.673,19.673,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.246v-2.338a10.327,10.327,0,0,0,1.16.492,22.027,22.027,0,0,0,13.961,0,10.26,10.26,0,0,0,1.16-.492ZM-38.865-62.5a21.389,21.389,0,0,0,15.121-.492v2.422c0,.091-.339.672-1.948,1.247a19.667,19.667,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.247v-2.422a10.115,10.115,0,0,0,1.16.492Zm-3.507,12.62c0,.091-.339.672-1.949,1.247a19.67,19.67,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.247v-2.338a10.151,10.151,0,0,0,1.16.491,22.019,22.019,0,0,0,13.961,0,10.211,10.211,0,0,0,1.16-.491Zm-16.281,2.965a10.151,10.151,0,0,0,1.16.491,22.022,22.022,0,0,0,13.961,0,10.211,10.211,0,0,0,1.16-.491v2.338c0,.091-.339.671-1.949,1.247a19.676,19.676,0,0,1-12.383,0c-1.611-.576-1.949-1.156-1.949-1.247Zm18.628,0a10.217,10.217,0,0,0,1.16.491,22.021,22.021,0,0,0,13.961,0,10.151,10.151,0,0,0,1.16-.491v2.338c0,.091-.339.671-1.948,1.247a19.678,19.678,0,0,1-12.383,0c-1.611-.576-1.949-1.156-1.949-1.247Zm14.333-1.718a19.678,19.678,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.247v-2.338a10.217,10.217,0,0,0,1.16.491,22.018,22.018,0,0,0,13.961,0,10.151,10.151,0,0,0,1.16-.491v2.338c0,.091-.339.672-1.948,1.247Zm1.948-6.549c0,.091-.339.672-1.948,1.247a19.678,19.678,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.247v-2.422a10.18,10.18,0,0,0,1.16.492,22.021,22.021,0,0,0,13.961,0,10.115,10.115,0,0,0,1.16-.492ZM-38.076-72.505a19.673,19.673,0,0,1,12.383,0c1.61.575,1.948,1.156,1.948,1.246s-.339.672-1.948,1.247a19.67,19.67,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.247s.339-.671,1.949-1.246ZM-57.493-57.03a21.389,21.389,0,0,0,15.121-.491v2.339c0,.091-.339.671-1.949,1.246a19.664,19.664,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.246v-2.339a10.088,10.088,0,0,0,1.16.491Zm13.172,19a19.676,19.676,0,0,1-12.383,0c-1.611-.576-1.949-1.156-1.949-1.247v-2.338a20.972,20.972,0,0,0,16.281,0v2.338c0,.091-.339.671-1.949,1.247Zm18.629,0a19.678,19.678,0,0,1-12.383,0c-1.611-.576-1.949-1.156-1.949-1.247v-2.338a20.972,20.972,0,0,0,16.281,0v2.338c0,.091-.339.671-1.948,1.247Zm18.628,0a19.678,19.678,0,0,1-12.383,0c-1.611-.576-1.949-1.156-1.949-1.247v-2.338a20.974,20.974,0,0,0,16.282,0v2.338c0,.091-.34.671-1.95,1.247Zm-12.383-13.1a19.669,19.669,0,0,1,12.383,0c1.61.575,1.95,1.155,1.95,1.246s-.34.672-1.95,1.247a19.672,19.672,0,0,1-12.383,0c-1.611-.575-1.949-1.156-1.949-1.247s.339-.671,1.949-1.246Zm0,0",
    transform: "translate(70 120.93)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPercentIcon);
export default __webpack_public_path__ + "static/media/money-percent-icon.274d3fb5904ef68482a42a917481e4df.svg";
export { ForwardRef as ReactComponent };